import * as TogglePrimitive from '@radix-ui/react-toggle'
import { type VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'
import * as React from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Toggle.module.scss'

const toggleVariants = cva(
  clsx(Styles.toggleBase, textVariants({ variant: 'nextSubtitle' })),
  {
    variants: {
      variant: {
        default: Styles.default,
        outline: Styles.outline
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)

type IToggleProps = React.ComponentPropsWithoutRef<
  typeof TogglePrimitive.Root
> &
  VariantProps<typeof toggleVariants>

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  IToggleProps
>(({ className, variant, ...props }, ref) => (
  <TogglePrimitive.Root
    data-testid="toggle"
    ref={ref}
    className={clsx(toggleVariants({ variant, className }))}
    {...props}
  />
))

Toggle.displayName = TogglePrimitive.Root.displayName

export type { IToggleProps }
export { toggleVariants }
export default Toggle
